<template>
    <div class="backgroundCalendar">
        <div class="ctn">
            <div class="flowHeader">
                <div class="ctnText1">流量监控</div>
                <div class="flowScopeSwitch">
                    <span class="flowScopeLabel" :class="{ 'flowScopeLabel--active': flowScope === 'general' }">通用流量</span>
                    <a-switch
                        size="small"
                        :checked="flowScope === 'annual'"
                        @change="onFlowScopeChange"
                        class="flowScopeSwitchEl"
                    />
                    <span class="flowScopeLabel" :class="{ 'flowScopeLabel--active': flowScope === 'annual' }">图源包年</span>
                </div>
            </div>
            <img src="~@/assets/calendar/日历关闭.png" alt="" class="icon3" @click="closeCalendar">
            <div ref="calendarLeftPanel" class="left">
                <img src="~@/assets/calendar/日历.png" alt="" class="icon1" @click="openMonthPicker">
                <img src="~@/assets/calendar/左箭头.png" alt="" class="icon2" @click="changeMonth(1)">
                <img src="~@/assets/calendar/右箭头.png" alt="" class="icon2" @click="changeMonth(2)" style="left: 284px;">
                <div class="leftText1">{{ year }}年{{ month }}月</div>
                <a-month-picker
                    ref="monthPickerRef"
                    v-model="currentMonth"
                    :open="monthPickerOpen"
                    :locale="locale"
                    format="YYYY-MM"
                    placeholder=""
                    :allow-clear="false"
                    :get-calendar-container="getMonthPickerContainer"
                    class="calendarSel"
                    @openChange="onMonthPickerOpenChange"
                    @change="onMonthSelected"
                />
                <!-- 日历 -->
                <div class="calendarCtn">
                    <div v-for="(item, index) in dayList" :key="index">
                        <div class="countCircle" @click="selectDay(item)" :class="[index==0 ? 'countCirclespe1':'', index==7||index==16||index==25 ? 'countCirclespe2':'']">
                            <div class="countCircle1" :id="'circleBig' + index"></div>  
                            <div class="countCircle2" :id="'circleSmall' + index" :class="{ 'selected': isSelected(item) }">{{item}}</div>
                        </div>
                    </div>
                </div>
                <div class="leftTextCtn">
                    <div class="leftTextCtnRow">
                        <div class="leftRowL1">{{ selectedDate.year }}年{{ pad2(selectedDate.month) }}月{{ pad2(selectedDate.day) }}日消耗流量：</div>
                        <div class="leftRowL2">{{ selectedTrafficStat.total }}次</div>
                    </div>
                    <template v-if="flowScope === 'general'">
                        <div class="leftTextCtnRow">
                            <div class="leftRowL1">每日免费流量：</div>
                            <div class="leftRowL2">{{ selectedTrafficStat.free }}次</div>
                        </div>
                        <div class="leftTextCtnRow">
                            <div class="leftRowL1">基础流量包流量：</div>
                            <div class="leftRowL2">{{ selectedTrafficStat.basis }}次</div>
                        </div>
                        <div class="leftTextCtnRow">
                            <div class="leftRowL1">高级流量包流量：</div>
                            <div class="leftRowL2">{{ selectedTrafficStat.senior }}次</div>
                        </div>
                    </template>
                    <div class="leftTextTip" :class="{ 'leftTextTip--annual': flowScope === 'annual' }">提示：流量统计结果可能存在延迟</div>
                </div>
            </div>
            <div class="right">
                <div class="rightHead">
                    <div class="rightHeadLeft" :class="{ 'rightHeadRight': type==1 }" @click="type=0">
                        <div class="rightText1" :class="{ 'rightText2': type==1 }">基础图源</div>
                    </div>
                    <div class="rightHeadLeft" :class="{ 'rightHeadRight': type==0 }" style="left: 208px;" @click="type=1"> 
                        <div class="rightText1" :class="{ 'rightText2': type==0 }">高级图源</div>
                    </div>
                </div>
                <div class="listHead">
                    <div class="listHead1">
                        <div class="listHead1Text">图源名称</div>
                    </div>
                    <template v-if="flowScope === 'general'">
                        <div class="listHead1" style="width: 53px;margin-left:45px;">
                            <div class="listHead1Text" style="left: 0;">免费流量</div>
                        </div>
                        <div class="listHead1" style="width: 53px;">
                            <div class="listHead1Text" style="left: 0;">基础流量</div>
                        </div>
                        <div class="listHead1" style="width: 53px;">
                            <div class="listHead1Text" style="left: 0;">高级流量</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="listHead1" style="width: 80px; margin-left: 79px;">
                            <div class="listHead1Text" style="left: 0;">图源包年流量</div>
                        </div>
                    </template>
                </div>
                <div class="listBody">
                    <div v-for="(row, index) in currentMkFlowRows" :key="'mk-flow-row-' + index" class="listRow">
                        <div :class="row.level === 0 ? 'listRowName' : 'listRowNameSub'" :title="row.sourceName" :style="{ paddingLeft: (row.level * 24) + 'px' }">
                            {{ row.sourceName }}
                        </div>
                        <template v-if="flowScope === 'general'">
                            <div class="listRowValue" style="margin-left: 45px;">{{ formatFlowValue(row.freeFlow) }}</div>
                            <div class="listRowValue">{{ formatFlowValue(row.basicFlow) }}</div>
                            <div class="listRowValue">{{ formatFlowValue(row.premiumFlow) }}</div>
                        </template>
                        <template v-else>
                            <div class="listRowValue" style="margin-left: 79px;">{{ formatFlowValue(row.annualFlow) }}</div>
                        </template>
                    </div>
                    <div v-if="currentMkFlowRows.length === 0" class="listEmptyText">暂无数据</div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
import { bus } from '@/bus.js' //引入bus.js定义的空的Vue实例
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
export default {
    components: {
    },
    data() {
        const now = moment();
        return {
            locale: zhCN,
            year:2025,
            month:11,
            currentMonth: moment(),
            selectedDate: {
                year: now.format('YYYY'),
                month: now.format('MM'),
                day: now.date(),
            },
            trafficList: Array.from({ length: now.daysInMonth() }, () => ({
                free: 0,
                basis: 0,
                senior: 0,
                annual: 0,
            })),
            mkFlowData: {
                baseicMk: { categoryName: '基础图源', flowVoList: [] },
                premiumMk: { categoryName: '高级图源', flowVoList: [] },
            },
            trialSuiteFlowList: [],
            type:0,
            monthPickerOpen: false,
            flowScope: 'general', // 'general' 通用流量 | 'annual' 图源包年

        };
    },
    computed: {
        selectedTrafficStat() {
            const day = Number(this.selectedDate && this.selectedDate.day);
            if (!day || day < 1 || day > this.trafficList.length) {
                return { total: 0, free: 0, basis: 0, senior: 0, annual: 0 };
            }
            const item = this.trafficList[day - 1] || { free: 0, basis: 0, senior: 0, annual: 0 };
            const free = Number(item.free || 0);
            const basis = Number(item.basis || 0);
            const senior = Number(item.senior || 0);
            const annual = Number(item.annual || 0);
            return {
                total: this.flowScope === 'annual' ? annual : (free + basis + senior),
                free,
                basis,
                senior,
                annual,
            };
        },
        //获取当月天数
        dayList() {
            const daysInMonth = new Date(this.year, this.month, 0).getDate();
            return Array.from({ length: daysInMonth }, (_, i) => i + 1);
        },
        // 计算百分比
        formattedTrafficPercentages() {
            return this.trafficList.map(item => {
                const free = Number(item.free || 0);
                const basis = Number(item.basis || 0);
                const senior = Number(item.senior || 0);
                const total = free + basis + senior;
                if (free === 0 && basis === 0 && senior === 0) {
                    return ['0%', '0%', '0%'];
                }
                if (total === 0) {
                    return ['0%', '0%', '0%'];
                }
                const freePercent = ((free / total) * 100).toFixed(1) + '%';
                const freeBasisPercent = (((free + basis) / total) * 100).toFixed(1) + '%';
                return [freePercent, freeBasisPercent, '100%'];
            });
        },
        currentMkFlowRows() {
            const list = this.type === 0
                ? ((this.mkFlowData.baseicMk && this.mkFlowData.baseicMk.flowVoList) || [])
                : ((this.mkFlowData.premiumMk && this.mkFlowData.premiumMk.flowVoList) || []);
            const baseRows = this.flattenMkFlowRows(list, 0);
            if (this.type === 0 && this.flowScope === 'annual' && Array.isArray(this.trialSuiteFlowList) && this.trialSuiteFlowList.length > 0) {
                const trialRows = this.trialSuiteFlowList.map((item) => ({
                    sourceName: item.sourceName,
                    freeFlow: 0,
                    basicFlow: 0,
                    premiumFlow: 0,
                    annualFlow: item.annualFlow,
                    level: 0,
                }));
                return baseRows.concat(trialRows);
            }
            return baseRows;
        },
    },
    created() {
        

    },
    mounted() {
        this.getToday()
        this.fetchUserPerDayFlow()
        this.fetchUserPerMkFlow()
        this.fetchTrialSuiteFlow()
    },
    methods: {
        getKey() {
            return localStorage.getItem("token");
        },
        closeCalendar() {
            this.$emit('close-calendar'); // 发送关闭事件
        },
        pad2(val) {
            return String(val).padStart(2, '0');
        },
        onFlowScopeChange(checked) {
            this.flowScope = checked ? 'annual' : 'general';
            this.colorCalendar();
        },
        //获取当年当月当日
        getToday(){
            this.year=this.currentMonth.format('YYYY')
            this.month=this.currentMonth.format('MM')
            const today = moment();
            this.selectedDate = {
                year: today.format('YYYY'),
                month: today.format('MM'), 
                day: today.date()
            };
            this.$forceUpdate()
        },
        //渲染圆环
        colorCalendar(){
            this.$nextTick(()=>{
                for(let i=0;i<this.dayList.length;i++){
                    let circleBig = document.getElementById("circleBig" + i);
                    if (!circleBig) continue;
                    if (this.flowScope === 'annual') {
                        // 图源包年模式：有包年消耗则统一蓝色，否则灰
                        const item = this.trafficList[i] || {};
                        const annual = Number(item.annual || 0);
                        circleBig.style.background = annual > 0 ? "#1677FF" : "#EAEAEA";
                    } else {
                        const percentages = this.formattedTrafficPercentages[i] || ['0%', '0%', '0%'];
                        if(!(percentages[0]=='0%'&&percentages[1]=='0%'&&percentages[2]=='0%')){
                            circleBig.style.background="conic-gradient(#00A855 0% "+percentages[0]+",#1677FF "+percentages[0]+" "+percentages[1]+",#722ED1 "+percentages[1]+" 100%)"
                        } else {
                            // 清空历史渲染，避免接口全0时残留彩色圆环
                            circleBig.style.background = "#EAEAEA";
                        }
                    }
                }
                this.$forceUpdate()
            })
        },
        buildEmptyTrafficList() {
            return this.dayList.map(() => ({ free: 0, basis: 0, senior: 0, annual: 0 }));
        },
        fetchUserPerDayFlow() {
            const userId = localStorage.getItem('userId') || '';
            if (!userId) {
                this.trafficList = this.buildEmptyTrafficList();
                this.$nextTick(() => this.colorCalendar());
                return;
            }
            const formData = new FormData();
            formData.append('userId', userId);
            formData.append('year', String(this.year));
            formData.append('month', String(this.month));
            this.axios.post('/tileflowapi/flow/package/queryUserPerDayFlow', formData, {
                headers: {
                    Authorization: 'Bearer ' + this.getKey(),
                },
            }).then((res) => {
                const body = res && res.data;
                const emptyList = this.buildEmptyTrafficList();
                if (body && Number(body.code) === 200 && Array.isArray(body.data)) {
                    body.data.forEach((item) => {
                        const day = moment(item.dayDate).date();
                        if (day >= 1 && day <= emptyList.length) {
                            emptyList[day - 1] = {
                                free: Number(item.freeFlow || 0),
                                basis: Number(item.basicFlow || 0),
                                senior: Number(item.premiumFlow || 0),
                                annual: Number(item.annualFlow || 0),
                            };
                        }
                    });
                }
                this.trafficList = emptyList;
                this.$nextTick(() => this.colorCalendar());
            }).catch(() => {
                this.trafficList = this.buildEmptyTrafficList();
                this.$nextTick(() => this.colorCalendar());
            });
        },
        fetchUserPerMkFlow() {
            const userId = localStorage.getItem('userId') || '';
            if (!userId) {
                this.mkFlowData = {
                    baseicMk: { categoryName: '基础图源', flowVoList: [] },
                    premiumMk: { categoryName: '高级图源', flowVoList: [] },
                };
                return;
            }
            const day = String((this.selectedDate && this.selectedDate.day) || moment().date());
            const formData = new FormData();
            formData.append('userId', userId);
            formData.append('year', String(this.year));
            formData.append('month', String(this.month));
            formData.append('day', day);
            this.axios.post('/tileflowapi/flow/package/queryUserPerMkFlow', formData, {
                headers: {
                    Authorization: 'Bearer ' + this.getKey(),
                },
            }).then((res) => {
                const body = res && res.data;
                if (body && Number(body.code) === 200 && body.data) {
                    this.mkFlowData = {
                        baseicMk: body.data.baseicMk || { categoryName: '基础图源', flowVoList: [] },
                        premiumMk: body.data.premiumMk || { categoryName: '高级图源', flowVoList: [] },
                    };
                } else {
                    this.mkFlowData = {
                        baseicMk: { categoryName: '基础图源', flowVoList: [] },
                        premiumMk: { categoryName: '高级图源', flowVoList: [] },
                    };
                }
            }).catch(() => {
                this.mkFlowData = {
                    baseicMk: { categoryName: '基础图源', flowVoList: [] },
                    premiumMk: { categoryName: '高级图源', flowVoList: [] },
                };
            });
        },
        fetchTrialSuiteFlow() {
            const userId = localStorage.getItem('userId') || '';
            if (!userId) {
                this.trialSuiteFlowList = [];
                return;
            }
            this.axios.post('/tilesapi/tiles/register/queryTileOrder', null, {
                headers: {
                    Authorization: 'Bearer ' + this.getKey(),
                },
            }).then((res) => {
                const body = res && res.data;
                if (!body || Number(body.code) !== 200 || !Array.isArray(body.data) || body.data.length === 0) {
                    this.trialSuiteFlowList = [];
                    return;
                }
                const trialSuite = body.data.find((item) => item && item.repName === '体验版' && item.status === '已付款');
                if (!trialSuite || !trialSuite.repositoryId) {
                    this.trialSuiteFlowList = [];
                    return;
                }
                const formData = new FormData();
                formData.append('userId', userId);
                formData.append('repositoryId', trialSuite.repositoryId);
                formData.append('year', String(this.year));
                formData.append('month', String(this.month));
                formData.append('day', String((this.selectedDate && this.selectedDate.day) || moment().date()));
                this.axios.post('/tilesapi/tiles/flow/queryUserPerMkFlow', formData, {
                    headers: {
                        Authorization: 'Bearer ' + this.getKey(),
                    },
                }).then((res2) => {
                    const body2 = res2 && res2.data;
                    if (!body2 || Number(body2.code) !== 200 || !Array.isArray(body2.data)) {
                        this.trialSuiteFlowList = [];
                        return;
                    }
                    const rows = body2.data
                        .filter((item) => item && Number(item.count) > 0)
                        .map((item) => ({
                            sourceName: (item.name || '') + '-切片套件',
                            annualFlow: Number(item.count || 0),
                        }));
                    this.trialSuiteFlowList = rows;
                }).catch((err) => {
                    console.warn('[trafficMonitor] queryUserPerMkFlow (trial suite) failed:', err);
                    this.trialSuiteFlowList = [];
                });
            }).catch((err) => {
                console.warn('[trafficMonitor] queryTileOrder failed:', err);
                this.trialSuiteFlowList = [];
            });
        },
        flattenMkFlowRows(list, level) {
            const rows = [];
            const scope = this.flowScope;
            const matchScope = (item) => {
                if (scope === 'annual') {
                    return Number(item.annualFlow || 0) > 0;
                }
                return Number(item.freeFlow || 0) > 0
                    || Number(item.basicFlow || 0) > 0
                    || Number(item.premiumFlow || 0) > 0;
            };
            // 节点自身或任一子孙命中则保留
            const hasMatchInTree = (item) => {
                if (matchScope(item)) return true;
                if (Array.isArray(item.childSourceList) && item.childSourceList.length) {
                    return item.childSourceList.some(hasMatchInTree);
                }
                return false;
            };
            (list || []).forEach((item) => {
                if (!hasMatchInTree(item)) return;
                rows.push({
                    sourceName: item.sourceName || '',
                    freeFlow: item.freeFlow,
                    basicFlow: item.basicFlow,
                    premiumFlow: item.premiumFlow,
                    annualFlow: item.annualFlow,
                    level,
                });
                if (Array.isArray(item.childSourceList) && item.childSourceList.length) {
                    rows.push(...this.flattenMkFlowRows(item.childSourceList, level + 1));
                }
            });
            return rows;
        },
        formatFlowValue(value) {
            const n = Number(value || 0);
            if (Number.isNaN(n)) return '0';
            if (Number.isInteger(n)) return String(n);
            return n.toFixed(3).replace(/\.?0+$/, '');
        },
        getMonthPickerContainer() {
            const el = this.$refs.calendarLeftPanel;
            return el || this.$el;
        },
        openMonthPicker() {
            this.monthPickerOpen = true;
        },
        onMonthPickerOpenChange(open) {
            this.monthPickerOpen = open;
        },
        /** 与 currentMonth 同步 year、month，并刷新月历与右侧列表 */
        applyCurrentMonthFromMoment(m) {
            const next = moment.isMoment(m) ? m.clone().startOf('month') : moment(m).startOf('month');
            this.currentMonth = next;
            this.year = next.format('YYYY');
            this.month = next.format('MM');
        },
        onMonthSelected(date) {
            if (!date) return;
            this.applyCurrentMonthFromMoment(date);
            this.monthPickerOpen = false;
            this.syncSelectedDayToVisibleMonth();
            this.fetchUserPerDayFlow();
            this.fetchUserPerMkFlow();
            if (this.flowScope === 'annual') {
                this.fetchTrialSuiteFlow();
            }
        },
        /** 切换月份后若选中日不在当月，则落到当月最后一天或 1 日 */
        syncSelectedDayToVisibleMonth() {
            const y = String(this.year);
            const m = String(this.month);
            const days = this.dayList.length;
            let day = Number(this.selectedDate && this.selectedDate.day) || 1;
            if (day > days) day = days;
            if (day < 1) day = 1;
            this.selectedDate = { year: y, month: m, day };
        },
        selectDay(day){
            this.selectedDate = {
                year: this.year,
                month: this.month,
                day: day
            };
            this.fetchUserPerMkFlow();
            if (this.flowScope === 'annual') {
                this.fetchTrialSuiteFlow();
            }
        },
        isSelected(day) {
            if (!this.selectedDate) return false;
            return this.selectedDate.year === this.year && 
                   this.selectedDate.month === this.month && 
                   this.selectedDate.day === day;
        },
        changeMonth(type) {
            const base = moment(this.currentMonth).startOf('month');
            this.currentMonth =
                type === 1 ? base.clone().subtract(1, 'month') : base.clone().add(1, 'month');
            this.year = this.currentMonth.format('YYYY');
            this.month = this.currentMonth.format('MM');
            this.syncSelectedDayToVisibleMonth();
            this.fetchUserPerDayFlow();
            this.fetchUserPerMkFlow();
            if (this.flowScope === 'annual') {
                this.fetchTrialSuiteFlow();
            }
        },
    },
    watch:{
        month() {
            this.$nextTick(() => {
                this.colorCalendar();
            });
        }
    }
};
</script>
<style scoped>
.backgroundCalendar{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.4);
    z-index: 100001;
}
.ctn{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 976px;
    height: 582px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #979797;
    overflow: visible;
}
.flowHeader{
    position: absolute;
    top: 32px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    z-index: 3;
}
.ctnText1{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #000000;
    line-height: 28px;
    white-space: nowrap;
}
.left{
    position: absolute;
    top: 92px;
    width: 488px;
    height:456px;
    border-right: 1px dashed #F0F0F0;
    overflow: visible;
    z-index: 2;
}
.icon1{
    position: absolute;
    left: 50px;
    cursor: pointer;
    z-index: 1;
}
.icon2{
    position: absolute;
    top: 2px;
    left: 176px;
    cursor: pointer;
}
.leftText1{
    position: absolute;
    left: 192px;
    width: 92px;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    text-align: center;
}
.calendarSel{
    position: absolute;left: 48px;width: 15px;top: 0px;opacity: 0;
}
::v-deep .ant-calendar-picker-icon{
    display: none;
}
::v-deep .ant-input{
    height: 34px;
}
.calendarCtn{
    position: relative;
    width: 392px;
    height: 280px;
    margin-top: 44px;
    margin-left: 50px;
}
.countCircle{
    position: relative;
    float: left;
    margin-right: 16px;
    margin-bottom: 16px;
    width: 40px;
    height: 40px;
    cursor: pointer;
}

.countCirclespe1{
    position: relative;
    float: left;
    margin-left: 112px;
    margin-bottom: 16px;
    width: 40px;
    height: 40px;
    cursor: pointer;
}
.countCirclespe2{
    position: relative;
    float: left;
    margin-left: 0px;
    margin-bottom: 16px;
    width: 40px;
    height: 40px;
    cursor: pointer;
}
.countCircle1{
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #EAEAEA;
}
.countCircle2{
    position: absolute;
    top: 4px;
    left: 4px;
    width: 32px;
    height: 32px; 
    background-color: #fff;
    border-radius: 50%;
    text-align: center;
    line-height: 32px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
}
.countCircle2:hover{
    background-color: #f0f0f0;
}
.countCircle2.selected {
  background-color: #f0f0f0 !important;
}
.countCircle2:not(.selected):hover {
  background-color: #f0f0f0;
}
.leftTextCtn{
    position: absolute;
    top: 327px;
    left: 50px;
    width: 430px;
    height: 129px;
}
.leftTextCtnRow{
    position: relative;
    margin-bottom: 8px;
    margin-left: 0;
    min-width: 230px;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #595959;
    line-height: 20px;
}
.leftRowL1{
    float: left;
    width: 185px;
    text-align: right;
}
.leftRowL2{
    float: left;
    width: auto;
    text-align: left;
}
.leftTextTip{
    position: absolute;
    left: 0;
    bottom: 0;
    width: auto;
    height: 17px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #8C8C8C;
    line-height: 17px;
    text-align: left;
}
.leftTextTip--annual{
    bottom: 84px;
}
.icon3{
    position: absolute;
    top: 26px;
    right: 26px;
    width: 25px;
    cursor: pointer;
}
.right{
    position: absolute;
    top: 92px;
    left: 487px;
    width: 488px;
    height:456px;
}
.rightHead{
    position: absolute;
    left: 35px;
    width: 416px;
    height: 31px;
    border-bottom: 1px solid #F0F0F0;
}
.rightHeadLeft{
    position: absolute;
    width: 208px;
    height: 31px; 
    background: #F0F0F0;
    cursor: pointer;
}
.rightText1{
    position: absolute;
    left: calc(50% - 44px);
    width: 88px;
    height: 31px;
    border-bottom: 2px solid #000000;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #000000;
    line-height: 31px;
    text-align: center;
}
.rightHeadRight{
    background: #fff;
}
.rightText2{
    border:none;
}
.listHead{
    position: absolute;
    left: 35px;
    top: 31px;
    width: 416px;
    height: 49px;
    border-bottom: 1px solid #D9D9D9;  
}
.listHead1{
    position: relative;
    float: left;
    width: 208px;
    height: 49px;
}
.listHead1Text{
    position: absolute;
    left: 86px;
    top: 24px;
    width: auto;
    height: 17px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #000000;
    line-height: 17px;
}
.listBody{
    position: absolute;
    left: 35px;
    top: 80px;
    width: 416px;
    height: 360px;
    overflow-y: auto;
}
.listRow{
    position: relative;
    width: 416px;
    min-height: 17px;
    margin-top: 8px;
    /* border-bottom: 1px solid #F0F0F0; */
}
.listRowName{
    float: left;
    width: 208px;
    height: 17px;
    line-height: 17px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.listRowNameSub{
    float: left;
    width: 208px;
    height: 17px;
    line-height: 17px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.45);
    box-sizing: border-box;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.listRowValue{
    float: left;
    width: 53px;
    margin-left: 0;
    height: 17px;
    line-height: 17px;
    text-align: left;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
}
.listEmptyText{
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    color: rgba(0,0,0,0.45);
    font-size: 14px;
}
/* 流量范围切换组件（通用流量 / 图源包年） */
.flowScopeSwitch{
    margin-left: 24px;
    display: flex;
    align-items: center;
}
.flowScopeLabel{
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.45);
    line-height: 20px;
}
.flowScopeLabel--active{
    font-family: PingFangSC-Medium, PingFang SC;
    color: #1890FF;
    font-weight: 500;
}
.flowScopeSwitchEl{
    margin: 0 16px;
    width: 34px;
    height: 18px;
    min-width: 34px;
}
.flowScopeSwitchEl.ant-switch:not(.ant-switch-checked){
    background-color: #1890FF;
}
</style>